import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function RimskoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Rimsko pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Rimsko pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Rimsko pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Rimsko pravo u istoriji univerzitetskog razvoja predstavlja
                najstariju disciplinu. Pregledom aktuelnih reformskih procesa na
                većini univerziteta ova disciplina i dalje zauzima nezaobilaznu
                polaznu stanicu u osnovama evropskih pravnih studija. Moderni
                pravni sistemi u svijetu su proučavali temeljne institute
                rimskog prava a naročito u najvažnijim pravnim kvalifikacijama.
                Strukturalna pravna terminologija načini pravnog rezonovanja
                argumentovanja i tumačenja sa pregledom evolutivnih promjena a
                naročito ekonomskih filozofskih i političkih uzroka tih promjena
                konkretnih pravnih instituta-predstavljaju nezaobilazne elemente
                pravne edukacije modernog pravnika.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješno savladanog predmeta student će moći: Analizirati
                procese nastanka i razvoja pravila i načela rimskog prava;
                Razlikovati temeljne pojmove institute i grane rimskog prava te
                uporediti njihove međusobne sličnosti i razlike; Kategorisati
                pojmove institute i grane rimskog prava u vremenskom kontekstu
                kao uvod za analizu savremenog prava; Steći osnovna znanja koja
                se tiču statusnog porodičnog nasljednog obligacionog stvarnog
                ugovornog deliktnog prava u doba Rima; Primijeniti načela
                pravila i rješenja rimskog prava na konkretna činjenična stanja
                u okviru praktičnih problemskih zadataka kao osposobljavanje
                studenata za case-study tehniku analize pravnih problema.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Uvod: Značaj rimskog prava karakter i izvori; četiri perioda
                  rimske istorije: Rim na sedam brežuljaka Republika Principat
                  Dominat
                </li>
                <li>
                  Recepcija rimskog prava: Rimsko pravo na Istoku Rimsko pravo u
                  Zapadnoj Evropi; Rimska teorija prava
                </li>
                <li>
                  Statusno pravo: pojam i značaj Pravna sposobnost: Status
                  libetatis status civitatis status familiae Trajanje
                  subjektiviteta Pravna lica Poslovna sposobnost: pojam tutela
                  tutorstvo i starateljstvo
                </li>
                <li>Porodično pravo: porodica brak položaj žene</li>
                <li>
                  Sudski postupak: građanski sudski postupak legisakcioni
                  postupak formularni postupak ekstraordinardni postupak
                  krivični postupak
                </li>
                <li>
                  Stvarno pravo: Opšti pogled; Stvari: pojam podjela; Svojina:
                  pojam i značaj privatna svojina kviritska svojina susvojina
                  tužbe za zaštitu svojine
                </li>
                <li>
                  Pribavljanje svojine: pribavljanje od države orinarni načini
                  derivativni načini; Pretorska svojina; Državina; Iura in re
                  aliena; založna prava; Službenosti; Ostala stvarna prava
                </li>
                <li>
                  Nasledno pravo: pojam i značaj zaostavština intestatsko
                  nasleđivanje testament prijem nasleđa
                </li>
                <li>
                  Obligaciono pravo: Opšti dio: pojam i elementi obligacionog
                  odnosa subjekti obezbjeđenje potraživanja krivica i štea bona
                  fides; Posebni dio: izvori pojam i zaključivanje ugovora
                  pisani ugovori realni ugovori konsensualni ugovori bezimeni
                  ugovori
                </li>
                <li>
                  Kvazikontrakti: pojam i vrste; Delikti: pojam i vrste delikti
                  ius civile-a pretorski delikti; Kvazidelikti; Docnja; Gašenje
                  obligacija: voljom stranaka i bez volje stranka; Prebijanje
                </li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava se izvodi kroz predavanja (ex chathedra) prezentacije
                diskusije izrade samostalnih istraživačkih radova – seminarskih
                radova rješavanje zadataka i praktičnih slučajeva vježbe u svrhu
                sistematizacije gradiva konsultacije itd.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 1V</td>
                    <td>
                      Uvod: Značaj rimskog prava karakter i izvori; Četiri
                      perioda rimske istorije: Rim na sedam brežuljaka Republika
                      Principat Dominat
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 1V</td>
                    <td>
                      Recepcija rimskog prava: Rimsko pravo na Istoku Rimsko
                      pravo u Zapadnoj Evropi; Rimska teorija prava
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 1V</td>
                    <td>
                      Statusno pravo: pojam i značaj Pravna sposobnost: Status
                      libetatis status civitatis status familiae
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 1V</td>
                    <td>
                      Trajanje subjektiviteta Pravna lica Poslovna sposobnost:
                      pojam tutela tutorstvo i starateljstvo
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 1V</td>
                    <td>
                      Porodično pravo; Sudski postupak: građanski sudski
                      postupak legisakcioni postupak formularni postupak
                      ekstraordinardni postupak krivični postupak+ Praktična
                      nastava.(dopuna i usavršavanje stečenih teorijskh znanja i
                      vještina kroz praktični rad) Simulacija sudskog postupka
                      uz zčešće svih studenata po grupama. Analiza slučajeva.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 1V</td>
                    <td>
                      Opšti pogled; Stvari: pojam podjela; Svojina: pojam i
                      značaj privatna svojina kviritska svojina susvojina tužbe
                      za zaštitu svojine;
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 1V</td>
                    <td>
                      Pribavljanje svojine: pribavljanje od države orinarni
                      načini derivativni načini;
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 1V</td>
                    <td>
                      Pretorska svojina; Državina; Iura in re aliena; založna
                      prava; Službenosti; Ostala stvarna prava
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 1V</td>
                    <td>
                      Nasledno pravo: pojam i značaj zaostavština intestatsko
                      nasleđivanje testament prijem nasleđa
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 1V</td>
                    <td>
                      Obligaciono pravo: Opšti dio: pojam i elementi
                      obligacionog odnosa subjekti obezbjeđenje potraživanja
                      krivica i štea bona fides;+ Praktična nastava.(dopuna i
                      usavršavanje stečenih teorijskh znanja i vještina kroz
                      praktični rad) Rješavanje svojinskih sporova. Pisanje
                      tužbi za zaštitu svojine.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 1V</td>
                    <td>Pojam i elementi pravnog odnosa; Subjekt prava</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 1V</td>
                    <td>
                      Ustavnost, zakonitost, vladavina prava i pravna država
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 1V</td>
                    <td>Primjena prava tumačenje prava i sistem prava</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4č / 3.00h</td>
                            <td>Ukupno: 80h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3č / 2.25h</td>
                            <td>Nastava + završni ispit: 60h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1č / 0.75h</td>
                            <td>Priprema i ovjera semestra: 6h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RimskoPravo;
